// UserMenu con avatar real y solo Logout.
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { actionLogout } from "store/actions/usersActions";
import {
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import { buildInitials, userAvatarBg, userHasPicture, userPictureUrl, userFullName, userFirstName } from "helpers/userAvatar";

function UserMenu() {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.userReducer);
  const [open, setOpen] = useState(false);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(actionLogout());
  };

  const goTo = (e, path) => {
    e.preventDefault();
    setOpen(false);
    history.push(path);
  };

  return (
    <Dropdown nav isOpen={open} toggle={() => setOpen(!open)} className="user-menu-nav">
      <DropdownToggle nav className="user-menu-toggle">
        <div
          className="user-menu-avatar"
          style={!userHasPicture(user) ? { background: userAvatarBg(user) } : undefined}
        >
          {userHasPicture(user) ? (
            <img src={userPictureUrl(user)} alt={userFirstName(user) || 'User'} />
          ) : (
            <span>{buildInitials(user)}</span>
          )}
        </div>
        <i className="now-ui-icons arrows-1_minimal-down user-menu-caret" />
      </DropdownToggle>
      <DropdownMenu right className="user-menu-dropdown">
        <div className="user-menu-header">
          <div
            className="user-menu-avatar lg"
            style={!userHasPicture(user) ? { background: userAvatarBg(user) } : undefined}
          >
            {userHasPicture(user) ? (
              <img src={userPictureUrl(user)} alt={userFirstName(user) || 'User'} />
            ) : (
              <span>{buildInitials(user)}</span>
            )}
          </div>
          <div className="user-menu-meta">
            <div className="user-menu-name">
              {user.isAuth ? (userFullName(user) || user.username || '—') : '—'}
            </div>
            {user.email && <div className="user-menu-email">{user.email}</div>}
          </div>
        </div>
        <DropdownItem divider />
        <DropdownItem tag="a" href="#" onClick={(e) => goTo(e, '/admin/profile')} className="user-menu-link">
          <i className="now-ui-icons users_circle-08" />
          <span>Profile</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem tag="a" href="#" onClick={handleLogout} className="user-menu-logout">
          <i className="now-ui-icons media-1_button-power" />
          <span>Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

export default UserMenu;
